import { render, staticRenderFns } from "./ViewError.vue?vue&type=template&id=5123611c&scoped=true&"
import script from "./ViewError.vue?vue&type=script&lang=js&"
export * from "./ViewError.vue?vue&type=script&lang=js&"
import style0 from "./ViewError.vue?vue&type=style&index=0&id=5123611c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5123611c",
  null
  
)

export default component.exports